module.exports = __webpack_public_path__ + "img/you-bought-a-house.ea99fb4a.png";